import { isServer } from "#src/utils/isServer.ts";

const includes = (path, allPaths) => {
  const paths = Array.isArray(path) ? path : [path];
  return paths.every((p) => allPaths.includes(p));
};

class ScriptLoader {
  paths: string[];
  loading: any;
  head: any;

  constructor() {
    this.paths = [];
    this.loading = {};
    this.head = !isServer && document.getElementsByTagName("head")[0];
  }

  has(path) {
    return includes(path, this.paths);
  }

  async load(path) {
    if (includes(path, this.paths)) {
      return path;
    }

    const paths = Array.isArray(path) ? path : [path];

    const createScript = (path) => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.async = true;
        script.src = path;

        script.onload =
          script.onerror =
          (script as any).onreadystatechange =
            () => {
              script.onload = (script as any).onreadystatechange = null;
              delete this.loading[path];
              this.paths.push(path);
              resolve(path);
            };

        this.head.insertBefore(script, this.head.lastChild);
      });
    };

    paths.forEach((path) => {
      if (!this.loading[path]) {
        this.loading[path] = createScript(path);
      }
    });

    const promises = Object.keys(this.loading)
      .filter((path) => includes(path, paths))
      .map((key) => this.loading[key]);

    return await Promise.all(promises);
  }
}

export default new ScriptLoader();
